import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useClinic } from "./context/ClinicContext";
const PatientContext = createContext();
export function PatientProvider({ children }) {
  const clinic = useClinic(),
    scope =
      (clinic?.clinicId || "") +
      ":" +
      (clinic?.currentUser?.uid || clinic?.currentUser?.id || "");
  const currentScope = useRef(scope);
  currentScope.current = scope;
  const [selection, setSelection] = useState({ scope, patient: null });
  const setSelectedPatient = useCallback(
    (value) =>
      setSelection((before) => {
        if (currentScope.current !== scope) return before;
        const previous = before.scope === scope ? before.patient : null;
        return {
          scope,
          patient: typeof value === "function" ? value(previous) : value,
        };
      }),
    [scope],
  );
  useEffect(() => {
    setSelection((before) =>
      before.scope === scope ? before : { scope, patient: null },
    );
  }, [scope]);
  const selectedPatient = selection.scope === scope ? selection.patient : null;
  return (
    <PatientContext.Provider value={{ selectedPatient, setSelectedPatient }}>
      {children}
    </PatientContext.Provider>
  );
}
export function usePatient() {
  return useContext(PatientContext);
}
